module.exports = __webpack_public_path__ + "static/media/Té helado con ron y amaretto.1359e057.webp";